import {ChangeDetectorRef, Component, ViewEncapsulation} from '@angular/core';
import {LogoComponent} from './logo.component';
import {Router} from "@angular/router";
import {ConfigService} from "../../services/config/config.service";
import {DomSanitizer} from "@angular/platform-browser";
import {MessageService} from "primeng/api";
import {TranslateService} from "@ngx-translate/core";
import {AppConfigService} from "../../services/app-config.service";
import {ThemeService} from "../../services/tools/theme.service";

@Component({
  selector: 'app-light-logo',
  templateUrl: './light-logo.component.html',
  styleUrls: ['./logo.component.scss', './light-logo.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LightLogoComponent extends LogoComponent {

  constructor(cdref: ChangeDetectorRef,
              messageService: MessageService,
              translateService: TranslateService,
              router: Router,
              configService: ConfigService,
              appConfigService: AppConfigService,
              sanitizer: DomSanitizer,
              themeService: ThemeService) {
    super(cdref, messageService, translateService, router, configService, appConfigService, sanitizer, themeService);
  }

  loadLogo(): void {
    if (this.appConfigService.imageCustomerLogoImg) {
      let objectURL = this.appConfigService.imageCustomerLogoImg;
      this.customerLogo = this.sanitizer.bypassSecurityTrustUrl(objectURL);
    }
  }

}
